import React, { useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useLazyGetNeighborhoodsQuery } from '../../Redux/Apis/Neighborhood'
import { setSelectedNeighborhood, setAvailableNeighborhoods } from '../../Redux/Slices/Auth'
import './style.css'

const NeighborhoodSelector = () => {
  const dispatch = useDispatch()
  const { user, selectedNeighborhood, availableNeighborhoods } = useSelector(state => state.authSlice)

  const [getNeighborhoods, { data: neighborhoodsData }] = useLazyGetNeighborhoodsQuery()

  useEffect(() => {
    // Fetch neighborhoods on mount
    if (user && (user.role === 'super_admin' || user.role === 'neighborhood_admin')) {
      getNeighborhoods()
    }
  }, [user])

  useEffect(() => {
    // Set available neighborhoods when data loads
    if (neighborhoodsData?.success && neighborhoodsData.data) {
      dispatch(setAvailableNeighborhoods(neighborhoodsData.data))

      // If no neighborhood selected, use default or first available
      if (!selectedNeighborhood && neighborhoodsData.data.length > 0) {
        const defaultNeighborhood = user?.defaultNeighborhood || neighborhoodsData.data[0]
        dispatch(setSelectedNeighborhood(defaultNeighborhood))
      }
    }
  }, [neighborhoodsData])

  const handleNeighborhoodChange = (neighborhood) => {
    dispatch(setSelectedNeighborhood(neighborhood))
  }

  // Only show for admins
  if (!user || (user.role !== 'super_admin' && user.role !== 'neighborhood_admin')) {
    return null
  }

  // Only show if there are multiple neighborhoods or user is super admin
  if (user.role !== 'super_admin' && availableNeighborhoods.length <= 1) {
    return null
  }

  if (!selectedNeighborhood) {
    return null
  }

  return (
    <div className="neighborhood-selector">
      <Dropdown>
        <Dropdown.Toggle variant="outline-light" id="neighborhood-dropdown" className="neighborhood-toggle">
          <i className="fas fa-map-marker-alt me-2"></i>
          {selectedNeighborhood.displayName || selectedNeighborhood.name}
        </Dropdown.Toggle>

        <Dropdown.Menu className="neighborhood-menu">
          <Dropdown.Header>Select Neighborhood</Dropdown.Header>
          {(availableNeighborhoods || []).map((neighborhood) => (
            <Dropdown.Item
              key={neighborhood._id}
              active={selectedNeighborhood._id === neighborhood._id}
              onClick={() => handleNeighborhoodChange(neighborhood)}
            >
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="fw-bold">{neighborhood.name}</div>
                  <small className="text-muted">{neighborhood.domain}</small>
                </div>
                {selectedNeighborhood._id === neighborhood._id && (
                  <i className="fas fa-check text-success ms-2"></i>
                )}
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default NeighborhoodSelector

